<mat-card>
    {{'efCategoryFees' | translate}}
</mat-card>

<form [formGroup]="categoryFeesForm" #formDir="ngForm" (ngSubmit)="saveForm()">
    <div align="end" class="row" style="padding:10px 10px 10px 10px;">
        <span class="spacer"></span>


        <button mat-raised-button color="primary" (click)="setAsDefault()" [disabled]="selectedCategory == 0">
            <mat-icon>done</mat-icon>
            {{'setAsDefault' | translate}}
        </button>
        &nbsp;
        <button mat-raised-button color="primary" type="submit" [disabled]="!categoryFeesForm.valid">
            <mat-icon>done</mat-icon>
            {{'submit' | translate}}
        </button>


    </div>

    <mat-card>

        <br>
        <mat-grid-list cols="5" rowHeight="50px">


            <mat-grid-tile colspan="1">
                <mat-form-field appearance="standard" style="margin-right: 5px;">
                    <mat-label>{{'userCatg' | translate}}</mat-label>
                    <mat-select formControlName="catgId" (selectionChange)="catgSelectChange()">
                        <mat-option *ngFor="let item of categories" [value]="item.id"> {{item.name}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="1">
                <button mat-raised-button color="primary" (click)="addNewCategory()">
                    <mat-icon>done</mat-icon>
                    {{'addNewCategory' | translate}}
                </button>
            </mat-grid-tile>

            <mat-grid-tile colspan="3">
                <mat-label>تفعيل النسبة المئوية</mat-label>
                &nbsp;
                &nbsp;
                <mat-slide-toggle (change)="EnableQrPercent($event)" [color]="color" [checked]="enableQrPercent">
                </mat-slide-toggle>

            </mat-grid-tile>
            <!-- <mat-grid-tile>
              
            </mat-grid-tile> -->



        </mat-grid-list>

        <div formArrayName="feesAmounts">
            <div *ngFor="let item of getFeesAmountControls();let i = index" [formGroupName]="i">

                <mat-grid-list cols="4" rowHeight="70px">

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'fromAmount' | translate}}</mat-label>
                            <input matInput formControlName="fromAmount" type="number">

                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'toAmount' | translate}}</mat-label>
                            <input matInput formControlName="toAmount" type="number">

                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'commission' | translate}}</mat-label>
                            <input matInput formControlName="fees" type="number">
                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'percent' | translate}}</mat-label>
                            <input matInput formControlName="percent" type="number">
                            <mat-icon [inline]="true" matSuffix>%</mat-icon>
                        </mat-form-field>
                    </mat-grid-tile>

                </mat-grid-list>


            </div>
        </div>


    </mat-card>
</form>



<ng-template #ModalCategory>

    <h1 mat-dialog-title>{{!updateMode ? ('create' | translate) : ('update' | translate) }}</h1>
    <div mat-dialog-content>


        <mat-form-field appearance="standard">
            <mat-label>{{'name' | translate}}</mat-label>
            <input matInput [(ngModel)]="categoryName">
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="saveCategory()">{{'submit' | translate}}</button>
    </div>

</ng-template>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>